import React, { useState, useEffect } from "react";
import {
  Title,
  Center,
  Text,
  ThemeIcon,
  Box,
  Flex,
  ActionIcon,
  Loader,
  Divider,
  Button,
} from "@mantine/core";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";

import { getAlertEntityInfoFromContext } from "./helpers";

import { DismissButton } from "./AlertList";

export default function AlertDetail({ alert, onDismiss }) {
  const { icon, color: alertColor } = getAlertEntityInfoFromContext(alert);
  const adminInfo = useSelector((state) => state.admin);
  const managerInfo = useSelector((state) => state.manager);

  return (
    <div>
      {/* {loading && (
        <Box
          mih={300}
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Center h="100%">
            <Loader color="gray.3" />
          </Center>
        </Box>
      )} */}
      <Box>
        <Flex mb={0} align="center" gap="sm">
          {/* <ThemeIcon color={alertColor} size="lg" variant="subtle">
              {(entityIcon[alert.entity] && entityIcon[alert.entity](24)) ||
                entityIcon.alert(24)}
            </ThemeIcon> */}
          <Text style={{ flexGrow: 1 }} size="sm" fw={600}>
            {alert?.title}
          </Text>
          {/* <ActionIcon
              variant="light"
              size="md"
              color="gray"
              radius="xl"
              onClick={onClose}
            >
              <IconX size={18} />
            </ActionIcon> */}
        </Flex>
        {/* <Divider mb="md" /> */}
        <Box
          // p="md"
          style={
            {
              // backgroundColor: `var(--mantine-color-${alertColor}-0)`,
              // borderRadius: "var(--mantine-radius-md)",
              // border: `1px solid var(--mantine-color-${alertColor}-2)`,
            }
          }
        >
          <Text size="sm" mt={2} c="gray.8">
            {alert?.message_text}
          </Text>
          {alert && (
            <Flex align="center" gap="xs" mt="sm">
              {alert.navigation_url && (
                <Box>
                  <Button
                    component={Link}
                    to={alert.navigation_url}
                    variant="white"
                    size="xs"
                    color={alertColor}
                    style={{
                      border: `2px solid var(--mantine-color-${alertColor}-5)`,
                    }}
                  >
                    View
                  </Button>
                </Box>
              )}
              <DismissButton
                reqData={{
                  organization_manager_id: managerInfo?.organization_manager_id,
                  location_manager_id: managerInfo?.location_manager_id,
                  admin_id: adminInfo?.admin_id,
                  notification_ids: [alert?.id],
                }}
                onSuccess={onDismiss}
              />
            </Flex>
          )}
        </Box>
      </Box>
    </div>
  );
}
